import { useSelector, useDispatch } from 'react-redux'
import { initialsSet } from '../actions'

const InitialsField = () => {
  const dispatch = useDispatch()
  const initials = useSelector((state) => state.bikeConfig.initials)

  return (
    <div className="velorbis-customizer-form-control">
      <input
        style={{ width: '179px', position: 'relative', right: '4px' }}
        type="text"
        value={initials || ''}
        placeholder="Enter name"
        maxLength="20"
        className="velorbis-customizer-input"
        onChange={(e) => dispatch(initialsSet(e.target.value))}
      />
    </div>
  )
}

export default InitialsField
